<template>
    <div class="tableCornerRadius bg-white">
        <div class="table-container">
            <table>
                <thead>
                    <th scope="col" v-for="presentColumn in columnNames" :key="presentColumn" :class="getColumnHeadWidth(presentColumn)" class="bg-white capitalize" @click="sort(presentColumn)">
                        <div v-if="presentColumn=='systemStatus'||presentColumn=='vendorStatus'||presentColumn=='risks'||presentColumn=='criticality'||presentColumn=='severity'||presentColumn=='securityCategory'||presentColumn=='likelihood'||column=='Facing'" class="flex justify-center" :class="getHeaderAlignment(presentColumn)">
                            <div>{{ getColumnLabel(presentColumn) }}</div>
                            <!-- <div class="sort cursor-pointer" :class="className == column ? classSort : 'opacity-50'"></div> -->
                            <div class="sort cursor-pointer" :class="className == presentColumn ? classSort : 'opacity-50'" v-if="getColumnLabel(presentColumn) != ''"></div>
                        </div>
                        <div v-else class="flex" :class="getHeaderAlignment(presentColumn)">
                            <div>{{ getColumnLabel(presentColumn) }}</div>
                            <div class="sort cursor-pointer" :class="className == presentColumn ? classSort : 'opacity-50'" v-if="getColumnLabel(presentColumn) != ''"></div>
                        </div>
                        
                    </th>
                    
                    <tr v-if="visibility">
                        <td v-for="(presentColumn, index) in columnNames" :class="[presentColumn === 'status' ? 'flex items-center justify-center' : '']" class="bg-white" :key="index">
                            <div :class="getFilterAlignment(presentColumn)">
                                <select v-if="isColumnArrayPresent(presentColumn) && presentColumn != 'priority'" class="filter-font-size " v-model="filters[presentColumn]" :class="filters[presentColumn] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'">   
                                    <option :value="filters.presentColumn" selected hidden disabled>Select</option>
                                    <option class="optionColors" v-for="option in getDropdownOptionsForFilter(presentColumn)" :key="option.id" :value="option.id">{{ option.value }}</option>
                                </select>
                                <select v-else-if="presentColumn == 'priority'" class="filter-font-size " v-model="filters[presentColumn]" :class="filters[presentColumn] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'">
                                    <option :value="filters.presentColumn" selected hidden disabled>Select</option>
                                    <option class="optionColors" v-for="option in getDbDropdownOptionsForFilter(presentColumn)" :key="option" :value="option.value">{{ option.key }}</option>
                                </select>
                                <select v-else-if="isColumnArrayPresentibDB(presentColumn)" class="filter-font-size" v-model="filters[presentColumn]" :class="filters[presentColumn] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'">
                                    <option :value="filters.presentColumn" selected hidden disabled>Select</option>
                                    <option class="optionColors" v-for="option in getDbDropdownOptionsForFilter(presentColumn)" :key="option" :value="option.value">{{ option.key }}</option>
                                </select>
                                <select v-else-if="presentColumn == 'vendorStatus'||presentColumn == 'systemStatus'" v-model="filters[presentColumn]" :class="filters[presentColumn] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'">
                                    <option :value="select" selected hidden disabled>Select</option>
                                    <option class="optionColors" v-for="pair in activeValues" :key="pair" :value="pair.id" >{{ pair.value }}</option>
                                </select>
                                <select v-else-if="presentColumn == 'Facing'" v-model="filters[presentColumn]" :class="filters[presentColumn] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'">
                                    <option :value="select" selected hidden disabled>Select</option>
                                    <option class="optionColors" v-for="pair in yesNo" :key="pair" :value="pair.id" >{{ pair.value }}</option>
                                </select>
                                <select v-else-if="presentColumn == 'criticality'" :class="filters[presentColumn] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="filters[presentColumn]">
                                    <option :value="select" selected disabled hidden>Select</option>
                                    <option class="optionColors" v-for="value in dbProcessCriticality" :key="value.value" :value="value.value">{{ value.key }}</option>
                                </select>
                                <select :class="filters[presentColumn] == null ? 'inputboxstylingForSelect criticalitystyling' : 'stylingForInputboxstylingForSelect criticalitystyling'" class="widthForRelationTypeSelect" v-model="filters[presentColumn]" v-if="presentColumn=='relationshipType'" >
                                    <option :value="filters.presentColumn" selected hidden disabled>Select</option>
                                    <option class="optionColors" v-for="pair in relationShipType" :key="pair" :value="pair.id">{{ pair.value }}</option>
                                    <!-- <option class="optionColors" v-for="value in getCriticalityOptions()" :key="value.id" :value="value.id">{{ value.value }}</option> -->

                                </select>
                                <div v-else-if="isFilterNotNecessary(presentColumn)"></div>
                                <input v-else-if="shouldShowDisabled(presentColumn)" type="text" class="disabledinputboxstyling" v-model="filters[columnName]" disabled placeholder=""  />
                                
                                <input v-else-if="!dropdownColumns.includes(presentColumn)" type="text" class="searchForInputBoxStyling filter-font-size" v-model="filters[presentColumn]" placeholder="Search" />
                            </div>
                        </td>
                    </tr>
                </thead>

                <tbody v-if="loadData == true">
                    <tr class="cursor-pointer rowHeight">
                        <td class="relative h-5" :colspan="columnNames.size">
                            <div class="flex items-center justify-center w-full h-16 skeleton">
                                <dots-loader/>
                            </div>
                        </td>
                    </tr>
                </tbody>

                <tbody v-else-if="sortedData.length == 0">
                    <tr class="cursor-pointer rowHeight">
                        <td class="relative h-10" :colspan="columnNames.size">
                            <div class="flex justify-center"><p class="text-xs font-normal">No Records Found</p></div>
                        </td>
                    </tr>
                </tbody>

                <tbody class="nonEmptyTable" v-else>
                    <tr v-for="(row, index) in sortedData" :key="row" class="cursor-pointer rowHeight" >
                        <td v-for="presentColumn in columnNames" :key="presentColumn" @mouseout="doFalse()" @click="actionOnClickingTableRow(row, index, presentColumn)" class="cursor-pointer relative">
                            <div v-if="row[presentColumn] == ''" :class="{'w-24 text-center':presentColumn == 'securityCategory'}">{{ 'N/A' }}</div>
                            
                            <div v-else-if="checkDateFormat(presentColumn)">
                                <p class="cursor-pointer text-xs w-26">{{ getDateFormat(row[presentColumn]) }}</p>
                            </div>

                            <div v-else-if="checkuserData(presentColumn)">
                                <div class="cursor-pointer text-xs">
                                    {{Object.keys(row[presentColumn]).includes('label') ? `${row[presentColumn].label}`:`${getOwnerName(row[presentColumn])}`}}
                                </div>
                            </div>
                            <div v-else-if="presentColumn == 'systemCount' ||presentColumn == 'risks'">
                                <div class="flex items-center justify-center" @mousemove="toolTip(presentColumn, $event, index, row, 'text')">
                                    {{ row[presentColumn] }}
                                </div>
                            </div>
                            <div v-else-if="presentColumn == 'Facing'">
                                <div class="flex justify-center">
                                    {{ isPublicFacing(row[presentColumn]) }}
                                </div>
                            </div>

                            <div v-else-if="presentColumn == 'vendorStatus' ||presentColumn == 'systemStatus'">
                                <div class="rounded-full w-5 h-5 bg-active mx-auto" @mousemove="toolTip(presentColumn, $event, index, row, 'circleButton')" v-if="row[presentColumn] == true"></div>
									<div class="rounded-full w-5 h-5 bg-error mx-auto" @mousemove="toolTip(presentColumn, $event, index, row, 'circleButton')" v-else></div>
									<div class="flex justify-center items-center bg-white opacity-0 lasttooltip absolute z-50 group-hover:opacity-100 border pointer-events-none" v-if="row[presentColumn] == true && pop == true">
										<img src="@/assets/tooltip.svg" alt="" class="absolute text-black bottom-full left-0 -mb-1 h-3.5 w-3" />
										<span class="text-black text-center text-xs"></span>
										Active
									</div>
									<div class="flex justify-center items-center bg-white opacity-0 lasttooltip absolute z-50 group-hover:opacity-100 border pointer-events-none cursor-pointer" v-if="row[presentColumn] == false && pop == true">
										<img src="@/assets/tooltip.svg" alt="" class="absolute text-black bottom-full left-0 -mb-1 h-3.5 w-3" />
										<span class="text-black text-center text-xs"></span>
										Inactive
									</div>
                            </div>  
                            <div v-else-if="presentColumn=='relationshipType'">
                                <div class="table-ellipsis" @mousemove="toolTip(presentColumn, $event, index, row, 'text')">
                                    {{ getRelationshipType(row[presentColumn]) }}
                                </div>
                            </div>
                            

                            <div v-else-if="isColumnArrayPresent(presentColumn)">
                                <div v-if="presentColumn == 'tier' || presentColumn == 'mitigationTier'">
                                    <div class="text-xs">
                                        {{ getColumnRealtedValueFromArray(row[presentColumn], presentColumn) }}
                                    </div>
                                </div>

                                <div v-else-if="presentColumn == 'subCategory'">
                                    {{ getColumnRealtedValueFromArray(row[presentColumn], presentColumn) }}
                                </div>

                                <div v-else-if="presentColumn == 'prioritypreview'" class="flex">
                                    <div class="flex items-center justify-center rounded h-5 w-24 px-2.5  regular" :class="bgColorForPriority(row[presentColumn])" v-if="row[presentColumn]">
                                        <div :class="textColorForPriority(row[presentColumn])">
                                            {{
                                                dbPriority.find((l) => {
                                                    return l?.value == row[presentColumn];
                                                })?.key|| 'N/A'
                                            }}
                                        </div>
                                    </div>
                                    <div class="pl-7" v-else>
                                        -
                                    </div>
                                </div>

                                <div v-else-if="getLabelsArrayForColumnInStore(presentColumn)" class="flex justify-center">
                                    
                                    <div v-if="presentColumn == 'severitypreview'">
                                        <div class="relative flex items-center justify-center regular">
                                            <div class="flex items-center justify-center rounded-full w-5 h-5" @mousemove="toolTip(presentColumn, $event, index, row, 'circle')" :class="colorPropBg('border', row.severitypreview)">
                                                <div class="severityCircle rounded-full" :class="colorPropBg('circle', row.severitypreview)"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="rounded h-5 w-28 mt-2 mb-3 flex items-center justify-center" @mousemove="toolTip(presentColumn, $event, index, row, 'text')" :class="colorRiskBg(row[presentColumn])">
                                        <div :class="colorRiskText(row[presentColumn])">
                                            {{getLabelDefinationName( row[presentColumn] )}}
                                        </div>
                                    </div>
                                </div>

                                <div v-else-if="presentColumn == 'severity'">
                                    <div class="relative flex items-center regular justify-center">
                                        <div class="flex items-center justify-center rounded-full w-5 h-5" @mousemove="toolTip(presentColumn, $event, index, row, 'circle')" :class="colorPropBg('border', row.severity)">
                                            <div class="severityCircle rounded-full" :class="colorPropBg('circle', row.severity)"></div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div v-else-if="presentColumn == 'publicFacing'">
                                    <div class="text-xs">
                                        {{ getColumnRealtedValueFromArray(row[presentColumn], presentColumn) }}
                                    </div>
                                </div>

                                <div v-else-if="presentColumn == 'type'">
                                    <div class="text-xs">
                                        {{ getColumnRealtedValueFromArray(row[presentColumn], presentColumn) }}
                                    </div>
                                </div>
                                 <div v-else-if="presentColumn == 'treatmentType'" class="flex">
                                    <div class="flex items-center justify-center rounded h-5 w-24 px-2.5  regular" :class="bgColorForTreatmentType(row[presentColumn])">
                                        <div :class="textColorForTreatmentType(row[presentColumn])">
                                            {{ getColumnRealtedValueFromArray(row[presentColumn], presentColumn) }}
                                        </div>
                                    </div>
                                </div>

                                <div v-else class="flex items-center justify-center relative rounded w-24 px-2.5 h-5 regular" :class="colorsForStatusesText(row[presentColumn])">
                                    <div class="w-full h-full absolute opacity-20 rounded" :class="bgColorsForStatuses(row[presentColumn])"></div>
                                    <div class="flex rounded w-32 items-center justify-center py-1 regular text-xs">
                                        <div class="text-xs">
                                            {{ getColumnRealtedValueFromArray(row[presentColumn], presentColumn) }}
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div v-else-if="presentColumn == 'impact'||presentColumn=='overallImpact'" class="flex items-center justify-center">
                                <div class="flex items-center justify-center rounded h-5 w-28 px-2.5" @mousemove="toolTip(presentColumn, $event, index, row,'label')" :class="colorRiskBg(row[presentColumn])">
                                    <div  class="table-ellipsisForValue" style="white-space: break-spaces;"  :class="colorRiskText(row[presentColumn])">
                                        {{getLabelFromColumnArrayStoreImpact(row[presentColumn])}}
                                    </div>
                                </div>
                            </div>

                            <div v-else-if="getLabelsArrayForColumnInStore(presentColumn)" class="flex justify-center">
                                <div class="flex items-center justify-center rounded h-5 w-28 px-2.5 regular" @mousemove="toolTip(presentColumn, $event, index, row, 'label')" :class="colorRiskBg(row[presentColumn])">
                                    <div class="table-ellipsisForValue" :class="colorRiskText(row[presentColumn])" style="white-space: break-spaces;">
                                        {{getLabelDefinationName(row[presentColumn]) }}
                                    </div>
                                </div>
                            </div>

                            <div v-else-if="presentColumn == 'History' ||presentColumn=='inActiveHistory'" class="flex justify-center items-center">
                                <div class="h-5 w-5">
                                    <img src="@/assets/history.svg" class="cursor-pointer h-5 w-5" />
                                </div>
                            </div>

                            <div v-else-if="presentColumn == 'deleteIcon' || presentColumn == 'deleteinfo'">
                                <div class="flex justify-center h-5 w-5">
                                    <img src="@/assets/deleteIcon.svg" class="h-5 cursor-pointer
                                    w-5 mx-2.5" />
                                </div>
                            </div>

                            <div v-else-if="presentColumn == 'actionButton' || presentColumn == 'tableDataActions'">
                                <div v-if="presentColumn == 'actionButton'" style="display: flex;align-items: center;justify-content: center;">
                                <fieldset>
                                    <!-- <div>
                                        <div class="flex justify-start items-center h-5 w-5">
                                            <img src="@/assets/ActionIcon.svg" class="h-5 w-5 cursor-pointer"  @click.stop="toggleDropdown($event,index,presentColumn)"/>
                                        </div>
                                    </div> -->
                                    <!-- <ul class="dropdown-menu ml-2 shadow-sm z-30 cursor-pointer" :class="isNearBottom(index) ? 'dropdown-up' : 'dropdown-menu1'" :style="dropdownStyle(index)"  v-if="showDropDown && selectedRowIndex == index">
                                        <li class="cursor-pointer lastChild border-b border-lightgrey hover:bg-lightgrey h-7 flex items-center" v-for="(option, index) in optionsValue" :key="index" @click="changeRoute(row, option.route)">
                                            <div class="flex items-center justify-between gap-2.5 pl-3" v-if="option.value == 'Accept'">
                                                <div class="h-5 w-5">
                                                    <img src="@/assets/Accept.svg" class="h-5 w-5" />
                                                </div>
                                                {{ option.value }}
                                            </div>
                                            <div class="flex items-center justify-between gap-2.5 pl-3" v-else-if="option.value == 'Mitigate'">
                                                <div class="h-5 w-5">
                                                    <img src="@/assets/Mitigate 1.svg" class="h-5 w-5" />
                                                </div>
                                                {{ option.value }}
                                            </div>
                                            <div class="flex items-center  justify-between gap-2.5 pl-3"  v-else-if="option.value=='Avoid'">
                                                <div class="h-5 w-5">
                                                    <img src="@/assets/Avoid.svg" class="h-5 w-5" />
                                                </div>
                                                {{option.value}}
                                            </div>
                                            <div class="flex items-center  justify-between gap-2.5 pl-3"  v-else-if="option.value=='Transfer'">
                                                <div class="h-5 w-5">
                                                    <img src="@/assets/Transfer.svg" class="h-5 w-5" />
                                                </div>
                                                {{option.value}}
                                            </div>
                                            <div class="flex items-center justify-between gap-2.5 pl-3" v-else-if="option.value == 'Reset'">
                                                <div class="h-5 w-5">
                                                    <img src="@/assets/Reset.svg" class="h-5 w-5" />
                                                </div>
                                                {{ option.value }}
                                            </div>
                                            <div class="flex items-center justify-between gap-2.5 pl-3" v-else-if="option.value == 'Delete'">
                                                <div class="h-5 w-5">
                                                    <img src="@/assets/DeleteRisk.svg" class="h-5 w-5" />
                                                </div>
                                                {{ option.value }}
                                            </div>
                                            <div class="flex items-center justify-between gap-2.5 pl-3" v-else-if="option.value == 'Clone'">
                                                <div class="h-5 w-5">
                                                    <img src="@/assets/Clone.svg" class="h-5 w-5" />
                                                </div>
                                                {{ option.value }}
                                            </div>
                                            <div class="flex items-center  justify-between gap-2.5 pl-3" @click="changePriority(row)"  v-else-if="option.value=='Priority'">
                                                <div class="h-5 w-5">
                                                    <img src="@/assets/Priority 1.svg" class="h-5 w-5" />
                                                </div>
                                                {{option.value}}
                                            </div>
                                        </li>
                                    
                                    </ul> -->
                                    <Button type="button" icon="pi pi-ellipsis-v" @click="actionToggleMenu($event, index)" style="background-color: white; color: black; border: white;"/>
                                    <Menu :ref="'menu' + index" :model="actionItems(row)" :popup="true" class="menuWidth"/>
                                </fieldset>
                                </div>
                                <div v-else-if="presentColumn == 'tableDataActions'">
                                    <fieldset>
                                    <!-- <div class=""> -->
                                        <!-- <div class="flex justify-center items-center h-5 w-5">
                                            <img src="@/assets/ActionIcon.svg" class="cursor-pointer h-5 w-5"   @click.stop="toggleDropdown($event,index,presentColumn)"/>
                                        </div> -->
                                    <!-- </div> -->
                                        <!-- <ul class="dropdown-menu shadow-sm z-30 absolute cursor-pointer" :class="isNearBottom(index) ? 'dropdown-up2' : ''" v-if="showDropDown && selectedRowIndex == index">
                                            <li class="cursor-pointer lastChild border-b border-lightgrey hover:bg-lightgrey h-7 flex items-center justify-between" v-if="true" @click="tableDataDeleteAction(row, index)">
                                                <div class="flex items-center w-full gap-2.5 pl-3" >
                                                    <div class="h-5 w-5">
                                                        <img src="../assets/DeleteRisk.svg" class="h-5 w-5" />
                                                    </div>
                                                {{ tableDataActionOptions[0].value }}
                                            </div>
                                        </li>
                                        <li class="cursor-pointer lastChild border-b border-lightgrey hover:bg-lightgrey h-7 flex items-center" @click="tableDataEditAction(row, index)">
                                                <div class="flex items-center w-full gap-2.5 pl-3" >
                                                    <div class="h-5 w-5">
                                                        <img src="../assets/editIcon.svg" class="h-5 w-5" />
                                                    </div>
                                                {{ tableDataActionOptions[1].value }}
                                            </div>
                                        </li>
                                    </ul> -->
                                    <Button type="button" icon="pi pi-ellipsis-v" @click="actionToggleMenu($event, index)" style="background-color: white; color: black; border: white;"/>
                                    <Menu :ref="'menu' + index" :model="tableActionsItems(row,index)" :popup="true" class="menuWidth"/>
                                </fieldset>
                                </div>
                            </div>
                            <div v-else>
                                <div class="table-ellipsis">
                                    <div @mousemove="toolTip(presentColumn, $event, index, row, 'text')">
                                        {{ row[presentColumn] }}
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
       </div>
        <pagination :dynamicPagination="dynamicPagination" @currentPageUpdate="paginationUpdations" :entityId="entityId" :sortedData="sortedData"></pagination>
    </div>
</template>
<style scoped>
.inputboxStylingForFilter {
    font-size:12px;
    width:112px;
}
.tableDataActionsStyle{
    width: 10%;
}
.widthfive{
    width: 5%;
}
.inputboxstylingForSelect .optionColors{
   color : #4D4D4D !important;
}
/* select{
    color:#a4a4a4;
} */
.lastChild:last-child {
    border: 0px;
}
.table-ellipsisForValue {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.activityStyle{
    width: 30%;
}
.optionFont {
    font-size: 12px !important;
}
.w-40 {
    width: 155px;
}
.dropdown-up2 {
    transform: translateY(-135%);
}
.ellipsis-container {
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-height: 1.5em;
    max-height: 3em;
}
.table-ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.displayHeatMapTable {
    height: 300px !important;
}
.displayDashboardTable {
    height: 360px !important;
}
.empty td {
    border-bottom: 1px solid #e9e9e9 !important;
}
.Blank {
    padding-left: 11% !important;
}
.actionButtonStyling {
    left: -76px;
}
.action-popup {
    bottom: -40px;
    left: -60px;
}
.bgredStyle {
    background-color: #ff0000;
}
.main-table{
  min-width: 1000px;
}
.fontSizingForPriority {
    font-size: 10px !important;
}
.severity-filter{
    width: 80px;
}
.tier-filter{
    width: 108px;
}
.risk-category-filter{
    width: 108px;
}
.risk-category-header{
    min-width: 130px;
    max-width: 132px;
}
.tier-header{
    min-width: 145px;
    max-width: 147px;
}
.dropdown-menu {
	border: 1px solid lightgray;
	position: absolute;
	background-color: white;
	border-radius: 6px;
	z-index: 999;
	top: 70%;
	right: 35%;
	width: 120px;
}
.widthForSelect{
    width : 100px !important;
}
.dropdown-menu1 {
	border: 1px solid lightgray;
	position: fixed;
	background-color: white;
	border-radius: 6px;
	z-index: 999;
	top: 60%;
	right: 20%;
	width: 120px;
}

.widthForSelect{
    width : 100px !important;
}


.veryLowOpacity{
    background-color: rgba(0, 176, 80, 0.2);
}
.LowOpacity{
    background-color: rgba(146, 208, 80, 0.2);
}
.ModerateOpacity{
    background-color: rgba(255, 153, 0, 0.2);
}
.HighOpacity{
    background-color: rgba(255, 0, 0, 0.2);
    /* background-color: #f7c4c4; */
}
.veryHighOpacity{
    background-color: rgba(192, 0, 0, 0.2);
}
.bgDisabledGrey{
	background-color: rgba(164, 164, 164, 0.2);
}
.bgError{
	background-color: rgba(255, 0, 0, 0.2);
}
.bgdarkred{
	background-color: rgba(192, 0, 0, 0.2);
}
.bgYellow{
	background-color: rgba(255, 153, 0, 0.2);
}
.bgLightGreen{
	background-color: rgba(0, 176, 80, 0.2);
}
.bgGreen{
	background-color: rgba(146, 208, 80, 0.2);
}
.bgElectricGreen{
	background-color: rgba(134, 0, 240, 0.2);
}
.bgForReview{
	background-color: rgba(8, 91, 150, 0.2);
}
.bgPrimary{
	background-color: rgba(21, 42, 67, 0.2);
}
.table-ellipsisForValue {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<script lang="ts">
import { emitter } from '@/main';
import _ from 'lodash';
import { defineComponent } from 'vue';
import pagination from '@/components/pagination.vue';
import moment from 'moment';
import { mapGetters } from 'vuex';
import dotsLoader from './dotsLoader.vue';
import Menu from 'primevue/menu';
import 'primeicons/primeicons.css';
import Button from 'primevue/button';
import type { MenuItem } from 'primevue/menuitem';
export default defineComponent({
    props: ['tableRowData', 'headersData', 'openPopup', 'navigate','loadData','tableProps'],
    data(): any {
        return {
            tableHead: [],
            tableRow: [],
            searchTableRow: [],
            entityId: '',
            visibility: false,
            className: '',
            classSort: '',
            currentSort: 'name',
            currentSortDir: 'asc',
            showDropDown: false,
            showBlock: false,
            checklabelsforallevents: [],
            statuses:[],
            currentPage: '',
            pageSize: '',
            dynamicPagination: '',

            pop: false,
            styling: { left: '', bottom: '' },
            tipText: '',
            tipColumn: '',
            tipIndex: '',
            filters: {},
            selectedTierMapping: [
                {
                    id: 1,
                    value: 'Organization'
                },
                {
                    id: 2,
                    value: 'Activity'
                },
                {
                    id: 3,
                    value: 'System'
                }
            ],
            activeValues: [
				{
					id: 1,
					value: 'Active'
				},
				{
					id: 2,
					value: 'Inactive'
				}
			],
            optionsValue: [
                {
                    id: 1,
                    value: 'Accept',
                    route: '/riskAcceptance'
                },
                {
                    id: 2,
                    value: 'Mitigate',
                    route: '/mitigateRisk'
                },
                {
                    id:3,
                    value:'Avoid',
                    route:'/avoid'
                },
                {
                    id:4,
                    value:'Transfer',
                    route:'/transfer'
                },
                {
                    id:9,
                    value:'Monitered',
                    route:'/monitered'
                },
                {
                    id: 5,
                    value: 'Clone',
                    route: '/clone'
                },
                {
                    id:6,
                    value:'Priority',
                    route:'/priority'
                },
                {
                    id: 7,
                    value: 'Reset',
                    route: '/reset'
                },
                {
                    id: 8,
                    value: 'Invalid',
                    route: '/deactive'
                }
            ],
            orgType: [
                {
                    id: 1,
                    value: 'Primary'
                },
                {
                    id: 2,
                    value: 'Subsidiary'
                },
                {
                    id: 3,
                    value: 'Branch'
                }
            ],
            type: [
                {
                    id: 1,
                    value: 'Primary'
                },
                {
                    id: 2,
                    value: 'Secondary'
                }
            ],
            myTasksStatus: [
                {
                    id: 10401,
                    value: 'Open'
                },
                {
                    id: 10402,
                    value: 'In Progress'
                },
                {
                    id: 10408,
                    value: 'Approval'
                },
                {
                    id: 10409,
                    value: 'In Review'
                },
                {
                    id: 10403,
                    value: 'Closed'
                }
            ],
            requestStatus: [
                {
                    id: 10401,
                    value: 'Open'
                },
                {
                    id: 10402,
                    value: 'In Progress'
                },
                {
                    id: 10403,
                    value: 'Approved'
                },
                {
                    id: 10404,
                    value: 'Invalid'
                },
                {
                    id: 10408,
                    value: 'Pending'
                },
                {
                    id: 10409,
                    value: 'On Hold'
                },
                {
                    id: 10410,
                    value: 'Rejected'
                }
            ],
            risksStatusValue: [
                {
                    id: 10401,
                    value: 'Open'
                },
                {
                    id: 10402,
                    value: 'In Progress'
                },
                {
                    id: 10403,
                    value: 'Accepted'
                },
                {
                    id: 10404,
                    value: 'Invalid'
                },
                {
                    id: 10405,
                    value: 'Mitigated'
                },
                {
                    id: 10406,
                    value: 'Partial'
                },
                {
                    id: 10419,
                    value: 'Avoid'
                },
            ],
            relationShipType:[
                {
                    id:20012,
                    value:'Direct Vendor'
                },
                {
                    id:20013,
                    value:'Subcontractor'
                },
                {
                    id:20014,
                    value:'Partner'
                },
                {
                    id:20015,
                    value:'Service Provider'
                },
                {
                    id:20016,
                    value:'Reseller'
                },
                {
                    id:20017,
                    value:'Affiliate'
                }
            ],
            requestedFor: [
                {
                    id: 10403,
                    value: 'Acceptance'
                },
                {
                    id: 10405,
                    value: 'Mitigate'
                },
                {
                    id: 10407,
                    value: 'Reset'
                },
                {
                    id: 10419,
                    value: 'Avoid'
                },
                {
                    id: 10404,
                    value: 'Invalid'
                }
            ],
            yesNo: [
                {
                    id: 1,
                    value: 'Yes'
                },
                {
                    id: 2,
                    value: 'No'
                }
            ],
            dropdownColumns: ['vendorStatus','systemStatus','criticality','relationshipType','securityCategory','severity','tier','priority','subCategory','approvalStatus','status','confValue','intValue','avaiValue','scValue','likeValue','legalValue','severitypreview','prioritypreview','infoClassValue','proCValue'],
            columns: [
                { key: 'statusCode', value: 'Status' },
                { key: 'systemName', value: 'System Name' },
                { key: 'controlName', value: 'Name' },
                { key: 'informationCategory', value: 'Category' },
                { key: 'processName', value: 'Process Name' },
                { key: 'organizationName', value: 'Location Name' },
                { key: 'target', value: 'Target Name' },
                { key: 'History', value: 'History' },
                { key: 'tier', value: 'Tier' },
                { key: 'createdAt', value: 'First Identified' },
                { key: 'updatedAt', value: 'Last Updated' },
                { key:'inActiveRisk',value:'risk' },
                { key: 'riskCategory', value: 'Category' },
                { key: 'systemCount', value: 'Occurances' },
                { key: 'taskStatus', value: 'Status' },
                { key: 'taskId', value: 'ID' },
                { key: 'mitigationtaskId', value: 'Id' },
                { key: 'mitigationTier', value: 'Tier' },
                { key: 'mitigationtarget', value: 'Target Name' },
                { key: 'createdAtfirst', value: 'First Identified' },
                { key: 'riskOwnerName', value: 'Owner' },
                { key: 'approvalStatus', value: 'Status' },
                { key:'vendorStatus',value:'Status'},
                {key:'systemStatus',value:'Status'},
                {key:'securityCategory',value:'Security Category'},
                {key:'signinglocation',value:'Signing Location'},
                {key:'orgType',value:'Type'},
                {key:'Facing',value:'Internet Facing?'},
                {key:'hostingModel',value:'Hosting Model'},
                {key:'hostingLocation',value:'Hosting Location'},
                {key:'ContractPeriod',value:'Contract Period'},
                {key:'relationshipType',value:'Relationship Type'},
                {key:'legalName',value:'Legal Name'},
                {key:'displayName',value:'Display Name'},
                {key:'vulnerabilityId',value:'Id'},
                {key:'threatId',value:'Id'},
                {key:'overallImpact',value:'impact'},
                {key:'treatmentType',value:'Treatment Type'}
            ],
            dropdownOptions: [
                {
                    key: 'Type',
                    value: [
                        {
                            id: 1,
                            value: 'Primary'
                        },
                        {
                            id: 2,
                            value: 'Subsidiary'
                        },
                        {
                            id: 3,
                            value: 'Branch'
                        }
                    ]
                },
                {
                  key:'hostingType',
                  value:[
                      {
                          id: 'On-premise',
                          value: 'On-premise'
                      },
                      {
                          id: 'Data center',
                          value: 'Data center'
                      },
                      {
                          id: 'Cloud',
                          value: 'Cloud'
                      },
                  ],
                },
                {
                    key: 'subCategory',
                    value: [
                        {
                            id: 10403,
                            value: 'Acceptance'
                        },
                        {
                            id: 10405,
                            value: 'Mitigate'
                        },
                        {
                            id: 10407,
                            value: 'Reset'
                        },
                        {
                            id: 10404,
                            value: 'Invalid'
                        },
                        {
                            id: 10419,
                            value: 'Avoid'
                        }
                    ]
                },
                {
                    key: 'status',
                    //task
                    value: [
                        {
                            id: 10401,
                            value: 'Open'
                        },
                        {
                            id: 10402,
                            value: 'In Progress'
                        },
                        {
                            id: 10403,
                            value: 'Approved'
                        },
                        {
                            id: 10404,
                            value: 'Invalid'
                        },
                        {
                            id: 10408,
                            value: 'Pending'
                        },
                        {
                            id: 10409,
                            value: 'On Hold'
                        },
                        {
                            id: 10410,
                            value: 'Rejected'
                        }
                    ]
                },
                {
                    key: 'approvalStatus',
                    //approval
                    value: [
                        {
                            id: 10403,
                            value: 'Approved'
                        },
                        {
                            id: 10408,
                            value: 'Pending'
                        },
                        {
                            id: 10410,
                            value: 'Rejected'
                        }
                    ]
                },
                {
                    key: 'statusCode',
                    //risk
                    value: [
                        {
                            id: 10401,
                            value: 'Open'
                        },
                        {
                            id: 10402,
                            value: 'In Progress'
                        },
                        {
                            id: 10403,
                            value: 'Closed'
                        },
                        
                        {
                            id: 10404,
                            value: 'Invalid'
                        },
                        {
                            id: 10405,
                            value: 'Mitigated'
                        },
                        {
                            id: 10406,
                            value: 'Partial'
                        },
                        {
                            id: 10408,
                            value: 'Pending'
                        },
                        {
                            id: 10409,
                            value: 'On Hold'
                        },
                        {
                            id: 10410,
                            value: 'Rejected'
                        },
                        {
                            id: 10419,
                            value: 'Avoid'
                        },
                        {
                            id:10425,
                            value:"Monitered"
                        }
                    ]
                },
                {
                    key: 'treatmentType',
                    //risk
                    value: [
                        {
                            id: 10425,
                            value: 'Monitored'
                        },
                        {
                            id: 10424,
                            value: 'Transfer'
                        },
                        {
                            id: 10419,
                            value: 'Avoid'
                        },
                        
                        {
                            id: 10403,
                            value: 'Accepted'
                        },
                        {
                            id: 10404,
                            value: 'Invalid'
                        },
                        {
                            id: 10407,
                            value: 'Reset'
                        },
                        
                    ]
                },
                {
                    key: 'tier',
                    value: [
                        {
                            id: 1,
                            value: 'Location'
                        },
                        {
                            id: 2,
                            value: 'Activity'
                        },
                        {
                            id: 3,
                            value: 'System'
                        }
                    ]
                },
                {
                    key: 'mitigationTier',
                    value: [
                        {
                            id: 1,
                            value: 'Organization'
                        },
                        {
                            id: 2,
                            value: 'Activity'
                        },
                        {
                            id: 3,
                            value: 'System'
                        }
                    ]
                },
                {
                    key: 'type',
                    value: [
                        {
                            id: 1,
                            value: 'Primary'
                        },
                        {
                            id: 2,
                            value: 'Secondary'
                        }
                    ]
                },
                {
                    key: 'taskStatus',
                    value: [
                        {
                            id: 10401,
                            value: 'Open'
                        },
                        {
                            id: 10402,
                            value: 'In Progress'
                        },
                        {
                            id: 10408,
                            value: 'Approval'
                        },
                        {
                            id: 10409,
                            value: 'In Review'
                        },
                        {
                            id: 10403,
                            value: 'Closed'
                        }
                    ]
                },
                {
                    key: 'publicFacing',
                    value: [
                        {
                            id: 1,
                            value: 'Yes'
                        },
                        {
                            id: 2,
                            value: 'No'
                        }
                    ]
                },
                {
                    key:'severity',
                    value:[
                        {
                            id:1,
                            value:'Negligible'
                        },
                        {
                            id:2,
                            value:'Minor'
                        },
                        {
                            id:3,
                            value:'Moderate'
                        },
                        {
                            id:4,
                            value:'High'
                        },
                        {
                            id:5,
                            value:'Critical'
                        }
                       
                    ]
                },
                {
                    key:'confValue',
                    value:[
                        {
                            id:1,
                            value:'Very Low'
                        },
                        {
                            id:2,
                            value:'Low'
                        },
                        {
                            id:3,
                            value:'Moderate'
                        },
                        {
                            id:4,
                            value:'High'
                        },
                        {
                            id:5,
                            value:'Very High'
                        }
                       
                    ]
                },
                 {
                    key:'intValue',
                    value:[
                        {
                            id:1,
                            value:'Very Low'
                        },
                        {
                            id:2,
                            value:'Low'
                        },
                        {
                            id:3,
                            value:'Moderate'
                        },
                        {
                            id:4,
                            value:'High'
                        },
                        {
                            id:5,
                            value:'Very High'
                        }
                       
                    ]
                },
                {
                    key:'avaiValue',
                    value:[
                        {
                            id:1,
                            value:'Very Low'
                        },
                        {
                            id:2,
                            value:'Low'
                        },
                        {
                            id:3,
                            value:'Moderate'
                        },
                        {
                            id:4,
                            value:'High'
                        },
                        {
                            id:5,
                            value:'Very High'
                        }
                       
                    ]
                },
                {
                    key:'scValue',
                    value:[
                        {
                            id:1,
                            value:'Very Low'
                        },
                        {
                            id:2,
                            value:'Low'
                        },
                        {
                            id:3,
                            value:'Moderate'
                        },
                        {
                            id:4,
                            value:'High'
                        },
                        {
                            id:5,
                            value:'Very High'
                        }
                       
                    ]
                },
                {
                    key:'likeValue',
                    value:[
                        {
                            id:1,
                            value:'Very Low'
                        },
                        {
                            id:2,
                            value:'Low'
                        },
                        {
                            id:3,
                            value:'Moderate'
                        },
                        {
                            id:4,
                            value:'High'
                        },
                        {
                            id:5,
                            value:'Very High'
                        }
                       
                    ]
                },
                {
                    key:'opsValue',
                    value:[
                        {
                            id:1,
                            value:'Very Low'
                        },
                        {
                            id:2,
                            value:'Low'
                        },
                        {
                            id:3,
                            value:'Moderate'
                        },
                        {
                            id:4,
                            value:'High'
                        },
                        {
                            id:5,
                            value:'Very High'
                        }
                       
                    ]
                },
                {
                    key:'severitypreview',
                    value:[
                        {
                            id:1,
                            value:'Very Low'
                        },
                        {
                            id:2,
                            value:'Low'
                        },
                        {
                            id:3,
                            value:'Moderate'
                        },
                        {
                            id:4,
                            value:'High'
                        },
                        {
                            id:5,
                            value:'Very High'
                        }
                       
                    ]
                },
                {
                    key:'infoClassValue',
                    value:[
                {
                    id: 1,
                    value: 'Public'
                },
                {
                    id: 2,
                    value: 'Internal'
                },
                {
                    id: 3,
                    value: 'Confidential'
                },
                {
                    id: 4,
                    value: 'Private'
                },
                {
                    id: 5,
                    value: 'Top Secret'
                }
            ]
                },
                {
                    key:'proCValue',
                    value:[
                        {
                            id:1,
                            value:'Very Low'
                        },
                        {
                            id:2,
                            value:'Low'
                        },
                        {
                            id:3,
                            value:'Moderate'
                        },
                        {
                            id:4,
                            value:'High'
                        },
                        {
                            id:5,
                            value:'Very High'
                        }
                       
                    ]
                },
                {
                    key:'orgValue',
                    value:[
                        {
                            id:1,
                            value:'Very Low'
                        },
                        {
                            id:2,
                            value:'Low'
                        },
                        {
                            id:3,
                            value:'Moderate'
                        },
                        {
                            id:4,
                            value:'High'
                        },
                        {
                            id:5,
                            value:'Very High'
                        }
                       
                    ]
                },
                {
                    key:'businessValue',
                    value:[
                        {
                            id:1,
                            value:'Very Low'
                        },
                        {
                            id:2,
                            value:'Low'
                        },
                        {
                            id:3,
                            value:'Moderate'
                        },
                        {
                            id:4,
                            value:'High'
                        },
                        {
                            id:5,
                            value:'Very High'
                        }
                       
                    ]
                },
                {
                    key:'techValue',
                    value:[
                        {
                            id:1,
                            value:'Very Low'
                        },
                        {
                            id:2,
                            value:'Low'
                        },
                        {
                            id:3,
                            value:'Moderate'
                        },
                        {
                            id:4,
                            value:'High'
                        },
                        {
                            id:5,
                            value:'Very High'
                        }
                       
                    ]
                },
                {
                    key:'finValue',
                    value:[
                        {
                            id:1,
                            value:'Very Low'
                        },
                        {
                            id:2,
                            value:'Low'
                        },
                        {
                            id:3,
                            value:'Moderate'
                        },
                        {
                            id:4,
                            value:'High'
                        },
                        {
                            id:5,
                            value:'Very High'
                        }
                       
                    ]
                },
                {
                    key:'legalValue',
                    value:[
                        {
                            id:1,
                            value:'Very Low'
                        },
                        {
                            id:2,
                            value:'Low'
                        },
                        {
                            id:3,
                            value:'Moderate'
                        },
                        {
                            id:4,
                            value:'High'
                        },
                        {
                            id:5,
                            value:'Very High'
                        }
                       
                    ]
                },
                {
                    key:'overAllValue',
                    value:[
                        {
                            id:1,
                            value:'Very Low'
                        },
                        {
                            id:2,
                            value:'Low'
                        },
                        {
                            id:3,
                            value:'Moderate'
                        },
                        {
                            id:4,
                            value:'High'
                        },
                        {
                            id:5,
                            value:'Very High'
                        }
                       
                    ]
                },
                {
                    key:'infopreview',
                    value:[
                {
                    id: 1,
                    value: 'Public'
                },
                {
                    id: 2,
                    value: 'Internal'
                },
                {
                    id: 3,
                    value: 'Confidential'
                },
                {
                    id: 4,
                    value: 'Private'
                },
                {
                    id: 5,
                    value: 'Top Secret'
                }
            ]
                }

            ],
            classificationData: [
                {
                    id: 10403,
                    value: 'Public'
                },
                {
                    id: 10407,
                    value: 'Internal'
                },
                {
                    id: 10406,
                    value: 'Confidential'
                },
                {
                    id: 10405,
                    value: 'Private'
                },
                {
                    id: 10410,
                    value: 'Top Secret'
                }
            ],
            priorityData: [
                {
                    id: 5,
                    value: 'P5'
                },
                {
                    id: 4,
                    value: 'P4'
                },
                {
                    id: 3,
                    value: 'P3'
                },
                {
                    id: 2,
                    value: 'P2'
                },
                {
                    id: 1,
                    value: 'P1'
                }
            ],
            users: [],
            optionsUserArray: [],
            selectedRowIndex: '',
            showTableActionsDropdown: false,
            tableDataActionOptions: [
                {
                    id: 1,
                    value: 'Delete'
                },
                {
                    id: 2,
                    value: 'Edit'
                }
            ],
            priorityObject: {},
            mouseY: 0,
            dynamicLeftPosition: 0,
            dynamicTopPosition: 0,
        };
    },
    components: {
        pagination,
        dotsLoader,
        Menu,
        Button
    },
    async mounted() {
        this.initialize();
        // await this.getAllUsers();
        emitter.on('visible', (isBoolean: any) => {
            this.visibility = isBoolean;
            this.visibility == false ? (this.filters = {}) : '';
        });
        // emitter.on('*', (type, booleanValue) => {
        // 	if (type == 'apps-sidemenubar' || type == 'toggle-sidebar') {
        // 		this.showDropDown == true ? (this.showDropDown = false) : '';
        // 	} else {
        // 		if (this.showBlock === true) {
        // 			this.showDropDown == true ? (this.showDropDown = booleanValue) : '';
        // 		} else if (this.showBlock === false) {
        // 			this.showDropDown == true ? '' : (this.showDropDown = booleanValue);
        // 			this.showBlock = true;
        // 		}
        // 	}
        // });
        emitter.on('*', (type, booleanValue) => {
            if (type === 'apps-sidemenubar' || type === 'toggle-sidebar') {
                if (this.showDropDown) {
                    this.showDropDown = false;
                }
                if (this.showTableActionsDropdown) {
                    this.showTableActionsDropdown = false;
                }
            } else {
                if (this.showBlock === true && type != 'deActiviteToolTip') {
                    if (this.showDropDown) {
                        this.showDropDown = booleanValue;
                    }
                    if (this.showTableActionsDropdown) {
                        this.showTableActionsDropdown = booleanValue;
                    }
                } else {
                    if (!this.showDropDown) {
                        this.showDropDown = booleanValue;
                    }
                    if (!this.showTableActionsDropdown) {
                        this.showTableActionsDropdown = booleanValue;
                    }
                }
                this.showBlock = true;
            }
        });
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    computed: {
        ...mapGetters({
            userInfo: 'userInfo',
            dbSeverity: 'dbSeverity',
            dbLikelihood: 'dbLikelihood',
            dbBussiness: 'dbBussiness',
            dbOrganization: 'dbOrganization',
            dbOperations: 'dbOperations',
            dbLegal: 'dbLegal',
            dbFinancial: 'dbFinancial',
            dbTechnical: 'dbTechnical',
            dbProcessCriticality: 'dbProcessCriticality',
            dbAvailability: 'dbAvailability',
            dbConfidentiality: 'dbConfidentiality',
            dbIntegrity: 'dbIntegrity',
            dbInformationClassification: 'dbInformationClassification',
            dbSecurityCategory: 'dbSecurityCategory',
            dbPriority: 'dbPriority',
            dbOverAllImpact:'dbOverAllImpact'
        }),

        sortedData: function (): any {
            return [...this.tableRow]
                .filter((row: any) => {
                    for (const key in this.filters) {
                        const inputValue = this.filters[key];
                        if (inputValue !== '' && row[key]) {
                            if (row[key] == 'N/A') {
                                return false;
                            } 
                            else if (Number.isInteger(row[key])) {
                                if (String(row[key]).toLowerCase().includes(String(inputValue).toLowerCase()) === false) {
                                    return false;
                                }
                            } else {
                                if (!row[key].toLowerCase().includes(inputValue.toLowerCase())) {
                                    return false;
                                }
                            }
                        }
                    }
                    return true;
                })
                .sort((a, b) => {
                    let modifier = 1;
                    if (this.currentSortDir === 'desc') modifier = -1;
                    if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                    if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                    return 0;
                })
                .filter((row, index) => {
                    this.dynamicPagination = index + 1;
                    let start = (this.currentPage - 1) * this.pageSize;
                    let end = this.currentPage * this.pageSize;
                    if (index >= start && index < end) return true;
                });
        },
        columnNames: function (): any {
            const names = new Set();
            for (const key of this.headersData) {
                if (key != 'entityId' && key != '_id') names.add(key);
            }
            return names;
        },
		isClickNearBottom: function (): any {
        // Get the height of the viewport
			const viewportHeight = window.innerHeight;

			// Set a threshold for how close to the bottom counts
			const threshold = 250; // Adjust as necessary

			// Check if the last recorded mouseY is near the bottom
			return this.mouseY > (viewportHeight - threshold);
		},
    },
    watch: {
        visibility(newValue) {
            if (newValue == false) {
                this.initialize();
            }
        },
        tableRowData: {
            handler(newVal, oldVal) {
                this.tableRow = this.tableRowData;
                this.initialize();
                // console.log('this.tableRowData[0]', this.tableRowData[0]);
            },
            deep: true
        }
    },
    methods: {
        actionToggleMenu(event:any, index:any) {
			let menu = this.$refs['menu' + index];
			if (Array.isArray(menu)) menu = menu[0];
			if (menu && typeof menu.toggle === 'function') {
				menu.toggle(event);
			}
		},
        tableActionsItems(row:any,value:any){
            return [
                {
                    label: 'Delete Risk',
                    icon: 'pi pi-trash',
                    command: () => this.tableDataDeleteAction(row,value)
                },
                {
                    label: 'Edit',
                    icon: 'pi pi-pencil',
                    command: () => this.tableDataEditAction(row,value)
                }
            ]
        },
        getRelationshipType(data:any){
            // console.log('this.relationShipTypssssssssssssssse',data)
            let relationship = this.relationShipType.find((rel:any)=>rel.id==data)            
            return relationship!=undefined?relationship.value:'N/A'
        },
        isPublicFacing(data:any){
            let publicFacing=this.yesNo.find((a:any)=>a.id==data)
            return publicFacing!=undefined?publicFacing.value:'N/A'
        },
        getStatusLabelFromColumn(columnName: any) {
            const option = this.dbProcessCriticality.find((criticality:any)=>criticality.value==columnName);
            return option ? option.key:[];
        },
        colorPriorityText(priority: any) {
			if (priority == 1) {
				return ['text-lightgreen font-semibold'];
			} else if (priority == 2) {
				return ['text-green font-semibold'];
			} else if (priority == 3) {
				return ['text-yellow font-semibold'];
			} else if (priority == 4) {
				return ['text-error font-semibold'];
			} else if (priority == 5) {
				return ['text-darkred font-semibold'];
			}
		},
        async getRiskApprovalStatuses(){
			let appId='10003';
			let entityId='10126';
			await this.$http.get(`${process.env.VUE_APP_AUTH_API}/${appId}/${entityId}/statuses`).then((result: any) => {				
			    this.statuses = result.data
			});
		},
        colorPriorityBg(priority: any) {
			if (priority == 1) {
				return ['bgLightGreen border-solid border border-lightgreen'];
			} else if (priority == 2) {
				return ['bgGreen border-solid border border-green'];
			} else if (priority == 3) {
				return ['bgYellow border-solid border border-yellow'];
			} else if (priority == 4) {
				return ['bgError border-solid border border-error'];
			} else if (priority == 5) {
				return ['bgdarkred border-solid border border-darkred'];
			}
		},
actionItems(row: any){
  return [
    {
      label: 'Accept',
      icon: 'pi pi-check-circle',
      command: () => this.changeRoute(row, '/riskAcceptance'),
    },
    {
      label: 'Mitigate',
      icon: 'pi pi-shield',
      command: () => this.changeRoute(row, '/mitigateRisk'),
    },
    {
      label: 'Avoid',
      icon: 'pi pi-ban',
      command: () => this.changeRoute(row, '/avoid'),
    },
    {
      label: 'Transfer',
      icon: 'pi pi-refresh',
      command: () => this.changeRoute(row, '/transfer'),
    },
    {
      label: 'Monitered',
      icon: 'pi pi-check',
      command: () => this.changeRoute(row, '/monitered'),
    },
    {
      label: 'Reset',
      icon: 'pi pi-replay',
      command: () => this.changeRoute(row, '/reset'),
    },
    {
      label: 'Invalid',
      icon: 'pi pi-trash',
      command: () => this.changeRoute(row, '/deactive'),
    },
    {
      label: 'Clone',
      icon: 'pi pi-copy',
      command: () => this.changeRoute(row, '/clone'),
    },
    {
      label: 'Priority',
      icon: 'pi pi-star',
      command: () => {this.changePriority(row),this.changeRoute(row, '/priority')}
    },
  ];
},

        getLabelFromColumnArrayStore(cameId:any){
            let labelObj:any;
            labelObj = this.checklabelsforallevents.find((l:any) => {return l.value == cameId;})
            
            if(labelObj == undefined){
                return 'N/A'
            }else{
                return labelObj.key;
            }  
        },
        getLabelFromColumnArrayStoreImpact(cameId:any){
            let labelObj:any;

            labelObj = this.dbOverAllImpact.find((l:any) => {return l?.value == cameId;})
            
            
            if(labelObj == undefined){
                return 'N/A'
            }else{
                return labelObj.key;
            }  
        },
        getPriorityLabel(cameId:any){
            let labelObj = this.dbPriority.find((l:any) => {return l.value == cameId;})
            if(labelObj == undefined){
                return 'N/A'
            }else{
                return labelObj.key;
            }
        },
        getLabelDefinationName(value:any){
            let obj =  this.checklabelsforallevents.find((l:any) => {
                return l.value == value; });
            if(obj!=undefined){
                return obj.key
            }else{
                return 'N/A'
            }
        },
        getLabelsArrayForColumnInStore(column: any) {
            if (column == 'securityCategory' || column=='scValue') {
                this.checklabelsforallevents = this.dbSecurityCategory;
                return true;
            }else if(column=='impact'||column=='overallImpact'){
                this.checklabelsforallevents = this.dbOverAllImpact;
                return true;
            }else if(column=='severitypreview'){
                this.checklabelsforallevents = this.dbSeverity;
                return true;
            }else if(column=='likelihood' || column=='likeValue'){
                this.checklabelsforallevents = this.dbLikelihood;
                return true;
            }else if(column=='confValue'){
                this.checklabelsforallevents = this.dbConfidentiality;
                return true;
            }else if(column=='intValue'){
                this.checklabelsforallevents = this.dbIntegrity;
                return true;
            }else if(column=='overAllValue'){
                this.checklabelsforallevents = this.dbOverAllImpact;
                return true;
            }else if(column=='avaiValue'){
                this.checklabelsforallevents = this.dbAvailability;
                return true;
            }else if(column=='scValue'){
                this.checklabelsforallevents = this.dbSecurityCategory;
                return true;
            }else if(column=='infoClassValue' || column=='infopreview'){
                this.checklabelsforallevents = this.dbInformationClassification;
                return true;
            }else if(column=='priority' || column=='prioritypreview'){
                this.checklabelsforallevents = this.dbPriority;
                return true;
            }else if(column=='proCValue'||column == 'criticality'){
                this.checklabelsforallevents = this.dbProcessCriticality;
                return true;
            }else if(column=='opsValue'){
                this.checklabelsforallevents = this.dbOperations;
                return true;
            }else if(column=='orgValue'){
                this.checklabelsforallevents = this.dbOrganization;
                return true;
            }else if(column=='businessValue'){
                this.checklabelsforallevents = this.dbBussiness;
                return true;
            }else if(column=='finValue'){
                this.checklabelsforallevents = this.dbFinancial;
                return true;
            }else if(column=='legalValue'){
                this.checklabelsforallevents = this.dbLegal;
                return true;
            }else if(column=='techValue'){
                this.checklabelsforallevents = this.dbTechnical;
                return true;
            }else if(column == 'confidentiality'){
                this.checklabelsforallevents = this.dbConfidentiality;
                return true
            }else if(column == 'integrity'){
                this.checklabelsforallevents = this.dbIntegrity;
                return true
            } else if(column == 'availability'){
                this.checklabelsforallevents = this.dbAvailability;
                return true
            } else if(column == 'overAllValue'){
                this.checklabelsforallevents = this.dbOverAllImpact;
                return true
            }else{
                return false;
            }
        },
        getFilterAlignment(column:any){
            if(column == 'impact'||column=='overallImpact'){
                return 'flex items-center justify-center pl-1';
            }else if(column == "securityCategory"){
                return 'pl-1';
            }
        },
        isNearBottom(index:any) {
			if(((index == 0))&&((this.sortedData.length == 1))){
				return false;
			}else{
				// console.log("this.isClickNearBottom", this.isClickNearBottom);
				// console.log("this.isClickNearBottom1", this.mouseY);
				// console.log("this.isClickNearBottom2", window.innerHeight);
				// Here, you can decide whether to consider the click position
				return this.isClickNearBottom || index >= (this.sortedData.length-1); // Adjust condition based on your needs
			}
		},
		dropdownStyle(index:any) {
            const baseStyle = {
                left: this.dynamicLeftPosition + 'px',
                top: this.dynamicTopPosition + 'px',
                display: this.showDropDown ? 'block' : 'none',transform:'',position:'fixed'
            };
            let windowWidth:any = window.innerWidth
            // Only apply transform if window width is less than 1200px and certain conditions are met
            if (windowWidth < 1200 && this.isClickNearBottom && index === 0) {
            
                baseStyle.transform = 'translateY(-123%)';
            }

            return baseStyle;
		},
		updateMouseY(event: MouseEvent) {
            this.mouseY = event.clientY; 
        },
        initialize() {
            this.tableRow = this.tableRowData;
            this.searchTableRow = this.tableRowData;

            this.tableRowData[0] == undefined ? '' : (this.entityId = this.tableRowData[0].entityId);
            // console.log('this.entityId', this.entityId);
        },
         getColumnHeadWidth(column: any) {
            if(this.tableProps != undefined){
                let a = this.tableProps.headerWidth.find((obj:any)=>{return obj.key == column});
                if(a!= undefined){
                    return a.value
                }else{
                    return ''
                }
            }
            else{
            if (column == 'infoAction' || column == 'systemName') {
                return 'w-36';
            }
            else if(column=='vulnerabilityId'||column=='deleteIcon'||column=='threatId'||column=='inActiveHistory'){
                return 'w-16'
            }
            else if(column=='actionButton'||column=='History'){
                 return 'widthfive'
            }
            else if(column=='tableDataActions'){
                return 'w-4'
            }
            else if (column == 'Name' || column == 'Email') {
                return 'w-1/4';
            }
            else if (column=='name'||column == 'status' || column == 'type' || column == 'Phone' || column == 'mitigationtaskId') {
                return 'w-44';
            }else if(column == 'mitigationTier'||column=='inActiveRisk'||column == 'processName' ||column=='mitigationtarget'||column=='riskCategory'){
                return'w-44'
            }else if(column=='tier'||column=='Category'||column=='vendorStatus'||column =='systemCount'||column=='criticality'||column=='vendor'||column=='Facing'){
                return'w-24'
            }else if(column=='first Identified'||column == 'organizationName'||column=='deactivated On'||column=='informationCategory'||column=='Display Name'||column=='Owner'||column=='ContractPeriod'||column =='displayName'||column=='information'||column=='hostingModel'||column=='owner'||column=='Owner'||column=='criticality'){
                return'w-36'
            }else if(column == 'securityCategory'){
                return'w-20'
            }else if(column=='risk'||column=='title'||column=='framework'||column=='legalName'||column=='target'){
                return'w-44'
            }else if(column=='treatmentType'||column=='relationshipType'||column=='vulnerability'||column=='riskOwnerName'||column=='orgType'||column=='Team'||column=='signinglocation'){
                return'w-32'
            }else if(column=='statusCode'||column=='createdAt'||column=='priority'||column=='updatedAt'||column=='approvalStatus'||column=='category'||column=='city'||column=='subCategory' || column=='taskStatus'|| column == 'threatEvent'|| column == 'threatCategory' || column == 'threatSource'||column == 'taskId'||column=='systemStatus'||column=='region'||column=='Location'||column=='country'||column=='Activity'){
                return'w-28'
            }else if(column=='severity'){
                return 'w-20'
            }
            else if(column=='risks'){
                return'w-20'
            }
            else if (column == 'description') {
                return 'w-48';
            }
            else if (column == 'Business Process Name'|| column == 'department' ) {
                return 'w-1/3';
            }
            else if (column == 'publicFacing' || column == 'hostingType'||column == 'impact'||column=='overallImpact'||column == 'likelihood'||column == 'systemName'||column == 'industrySectorName') {
                return 'w-1/5';
            }
            else if (column == 'target' || column == 'mitigationtarget') {
                return 'w-1/6';
            }else if(column == 'controlName'||column=='category'||column=='createdAtfirst'||column=='hostingLocation'){
                return 'w-44';
            }
            else if (column == 'securityCategory') {
                return 'flex items-center justify-center w-32';
            }else if( column == 'confLabel' || column == 'intLabel' || column == 'avaiLabel' || column == 'scLabel' ||
                column == 'likeLabel' || column == 'opsLabel' || 
                column == 'infoClassLabel' || column == 'proCLabel' || column == 'orgLabel' || column == 'businessLabel' || column == 'techLabel' || column == 'finLabel' || column == 'legalLabel'|| column == 'vulnerability' || column == 'confValue' || column == 'intValue' || column == 'avaiValue' || column == 'scValue' ||
                column == 'likeValue' || column == 'opsValue' || column == 'severitypreview' || column == 'prioritypreview' ||
                column == 'infoClassValue' || column == 'proCValue' || column == 'orgValue' || column == 'businessValue' ||
                column == 'techValue' || column == 'finValue' || column == 'legalValue' || column=='overAllLabel' || column == 'overAllValue' || column == 'sevLabel' || column == 'severitypreview' || column == 'prioLabel' || column == 'systemName'||column=='severitypreview'){
                return 'w-1/5';
            }
            // else if ( column == 'severity') {
            //     return 'w-1/6';
            // }
            else if (column == 'History') {
                return 'w-4';
            } 
            // else if (column == 'category') {
            //     return 'w-44';
            // }
            else {
                return '';
            }
        }
        },

        // getColumnHeadWidth(column: any) {
        //     if (column == 'category' || column == 'securityCategory' || column == 'information' || column == 'risk' || column == 'threatSource') {
        //         return 'w-56';
        //     }else if (column == 'severity' || column == 'impact' || column == 'likelihood' || column == 'threatId' ||  column == 'vulnerabilityId' || column=='securityCategory' || column =='systemName' || column == 'publicFacing' || column == 'hostingType') {
        //         return 'w-36';
        //     }else if( column == 'confLabel' || column == 'intLabel' || column == 'avaiLabel' || column == 'scLabel' ||
        //         column == 'likeLabel' || column == 'opsLabel' || 
        //         column == 'infoClassLabel' || column == 'proCLabel' || column == 'orgLabel' || column == 'businessLabel' || column == 'techLabel' || column == 'finLabel' || column == 'legalLabel'|| column == 'threatCategory' || column == 'threatEvent'|| column == 'vulnerability' || column == 'confValue' || column == 'intValue' || column == 'avaiValue' || column == 'scValue' ||
        //         column == 'likeValue' || column == 'opsValue' || column == 'severitypreview' || column == 'prioritypreview' ||
        //         column == 'infoClassValue' || column == 'proCValue' || column == 'orgValue' || column == 'businessValue' ||
        //         column == 'techValue' || column == 'finValue' || column == 'legalValue' || column=='overAllLabel' || column == 'overAllValue' || column == 'sevLabel' || column == 'severitypreview' || column == 'prioLabel' || column == 'systemName'){
        //         return 'w-32'
        //     }else if(column == 'description'){
        //         return 'w-52'
        //     }else if(column=='tableDataActions') {
        //         return 'w-24'
        //     }
        //     // else if (column == 'vulnerability') {
        //     //     return 'w-2/5';
        //     // } else if (column == 'securityCategory') {
        //     //     return 'flex items-center justify-center';
        //     // } 
        //     // else if (column == 'actionButton' || column == 'History' || column == 'tableDataActions') {
        //     //     return 'w-20';
        //     // } else {
        //     //     return '';
        //     // }
        // },
         getHeaderAlignment(column: any)
        {
            //for future usage , written conditions individuallly
            if(column == 'priority'||column=='Facing')
            {
                return 'flex justify-center';
            }else if(column == 'securityCategory')
            {
                return '';
            }
            else if(column == 'status')
            {
                return 'w-28 pl-4';
            }else if(column =='actionButton'){
                return 'w-4'
            }
            else if(column == 'Name')
            {
                return 'w-36';
            }
            else if( column =='Team'||column == 'Contract Start Date' || column == 'Contract Expiry Date'||column=='city'||column=='vendor'||column=='country'||column=='region'){
                return 'w-20'
            }
            else if(column == 'Job Title'||column=='category')
            {
                return 'w-36';
            }
            else if(column == 'mitigationtaskId'||column == 'vulnerabilityId')
            {
                return 'w-16';
            }
            else if(column == 'type' || column == 'controlName' || column == 'mitigationTier'||column=='owner')
            {
                return 'w-28';
            }
            else if(column == 'Email'||column=='first Identified'||column=='deactivated On' || column == 'Phone'||column=='hostingModel'||column=='hostingLocation' ){
                return 'w-28';
            }
            else if(column == 'Display Name')
            {
                return 'w-36';
            }
            else if(column == 'statusCode')
            {
                return 'w-16 justify-center';
            }
            else if(column == 'createdAtfirst'||column =='Owner'||column=='displayName')
            {
                return 'w-36';
            }
            else if(column == 'taskStatus')
            {
                return 'w-24 justify-center';
            }
            else if(column=='impact'||column=='overallImpact')
            {
                return ' items-center justify-center';
            } 
            else if(column=='category')
            {
                return 'w-16';
            }else if(column=='approvalStatus'){
                return 'w-16 pl-5';
            }
            // else if(column == 'severitypreview')
            // {
            //     return 'items-center justify-center';
            // } 
            else if(column == 'tier' )
            {
                return 'w-28';
            }
            else if(column=='subCategory')
            {
                return 'w-28';
            }
            else if(column == 'riskOwner' || column == 'riskOwnerName')
            {
                return 'w-24';
            }
            else if(column =='Activity'||column=='vulnerability'){
                return 'w-60'
            }
            else if(column=='Location'){
                return 'w-20'
            }
            // else if(column == 'hostingType' )
            // {
            //     return 'w-36';
            // }
            else if(column == 'information'||column=='owner')
            {
                return 'w-32';
            }
            
            // else if(column == 'description' )
            // {
            //     return 'w-32';
            // }
            // else if(column == 'systemName' )
            // {
            //     return 'w-36';
            // }
            // else if(column == 'securityCategory')
            // {
            //     return 'w-full items-center justify-center';
            // }
            else if(column == 'infopreview')
            {
                return 'items-center justify-center';
            }
            else if(column == 'systemCount')
            {
                return 'items-center justify-center';
            }
            else if(column=='legalName'){
                return 'w-44'
            }
            // else if(column == 'overAllValue')
            // {
            //     return 'items-center justify-center';
            // }
            else if(column == 'tableDataActions'){
                return 'tableDataActionsStyle'
            }
            else if(column=='Facing'){
                return 'w-10'
            }
            // else if(column == 'severity'){
            //     return 'w-20'
            // }
            else if(column == 'createdAt'||column == 'updatedAt')
            {
                return 'w-20';
            }
            else if(column == 'risk' )
            {
                return 'w-24';
            }
            else if(column == 'mitigationtarget')
            {
                return 'w-40';
            }
            else if(column == 'target')
            {
                return 'w-28';
            }
            else if(column=='name' )
            {
                return 'w-32';
            }
            else if(column=='Category'||column=='orgType' )
            {
                return 'w-20';
            }
            else if(column == 'organizationName'||column=='relationshipType'||column=='ContractPeriod' )
            {
                return 'w-36';
            }
            else if(column == 'riskCategory'||column=='signinglocation')
            {
                return 'w-32';
            }
            else if(column == 'processName'||column=='category' ||column=='organizationName' ||column=='systemName')
            {
                return 'w-40';
            }
            else if(column == 'confValue' || column == 'intValue' || column == 'avaiValue' || column == 'scValue' ||
            column == 'likeValue' || column == 'opsValue' || column == 'prioritypreview' ||
            column == 'infoClassValue' || column == 'proCValue' || column == 'orgValue' || column == 'businessValue' ||
            column == 'techValue' || column == 'finValue' || column == 'legalValue' || column == 'overAllValue'){
                return 'pl-6';
            }
            else{
                return '';
            }
        },
        getFilterPosition(column:any){
            if(column == 'priority')
            {
                return '';
            }
            else if(column == 'statusCode')
            {
                return 'flex items-center justify-center';
            }
            else if(column == 'severity'  || column == 'severitypreview' || column == 'impact' ||column=='overallImpact'|| column == 'likelihood')
            {
                return 'flex items-center justify-center';
            } 
            else if(column == 'securityCategory')
            {
                return 'flex items-center justify-center';
            }
            else if(column == 'infopreview')
            {
                return 'flex items-center justify-center';
            }
            else if(column == 'overAllValue')
            {
                return 'flex items-center justify-center';
            }
           else if(column == 'confValue' || column == 'intValue' || column == 'avaiValue' || column == 'scValue' ||
            column == 'likeValue' || column == 'opsValue' || column == 'prioritypreview' ||
            column == 'infoClassValue' || column == 'proCValue' || column == 'orgValue' || column == 'businessValue' ||
            column == 'techValue' || column == 'finValue' || column == 'legalValue'){
                return 'flex';
            }
            else{
                return '';
            }
        },
        getFilterSize(column: any)
        {
            //for future usage , written conditions individuallly
            if(column == 'priority')
            {
                return 'w-16';
            }
            // else if(column == 'statusCode')
            // {
            //     return 'w-16';
            // }
            else if(column == 'severity'  || column == 'severitypreview')
            {
                return 'severity-filter';
            } 
            else if(column == 'tier')
            {
                return 'tier-filter';
            }
            else if(column == 'riskCategory')
            {
                return 'risk-category-filter';
            }
            else if(column == 'securityCategory')
            {
                return 'w-28';
            }
            else if(column == 'infopreview')
            {
                return 'w-28';
            }
            else if(column == 'systemCount'||column=='risks'){
                return 'flex items-center justify-center w-20';
            }
            else if(column == 'overAllValue')
            {
                return 'w-28';
            }
            else if(column == 'confValue' || column == 'intValue' || column == 'avaiValue' || column == 'scValue' ||
            column == 'likeValue' || column == 'opsValue' || column == 'prioritypreview' ||
            column == 'infoClassValue' || column == 'proCValue' || column == 'orgValue' || column == 'businessValue' ||
            column == 'techValue' || column == 'finValue' || column == 'legalValue'){
                return 'w-28';
            }
            else{
                return '';
            }

        },
        getPaddingForEmptyColumnHead(column: any) {
            if (column == 'securityCategory') {
                return 'pl-14';
            } else if (column == 'updatedAt') {
                return 'pl-0';
            } else {
                return 'pl-6';
            }
        },
        paginationUpdations(currentPage: any, pageSize: any) {
            this.currentPage = currentPage;
            this.pageSize = pageSize;
        },
        sort(tableHead: any) {
            this.className = tableHead;
            if (tableHead === this.currentSort) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            }
            this.currentSort = tableHead;
            this.classSort = this.currentSortDir === 'asc' ? 'sort_asc' : 'sort_desc';
        },
        navigateWorkLog(rowData: any) {
            if (this.$route.path.includes('/systemInformation') && this.$route.path.includes('/org/system')) {
                this.$router.push({ name: 'worklogFromSystem', params: { riskId: rowData._id, systemId: rowData.systemId }, query: { systems: true } });
            } else if (this.$route.path.includes('/processInformation') && this.$route.path.includes('/org/process')) {
                this.$router.push({ name: 'worklogFromProcess', params: { riskId: rowData._id, processId: rowData.processId }, query: { process: true } });
            } else if (this.$route.path.includes('/organizationInformation')) {
                this.$router.push({ name: 'worklogFromOrganization', params: { riskId: rowData._id, orgId: rowData.orgId }, query: { organization: true } });
            } else if (this.$route.path.includes('/systemRisks')) {
                this.$router.push({ name: 'worklogFromSystem', params: { riskId: rowData._id, systemId: rowData.systemId }, query: { Risks: true } });
            } else if (this.$route.path.includes('/processRisks')) {
                this.$router.push({ name: 'worklogFromProcess', params: { riskId: rowData._id, processId: rowData.processId }, query: { Risks: true } });
            } else if (this.$route.path.includes('/orgRisks')) {
                this.$router.push({ name: 'worklogFromOrganization', params: { riskId: rowData._id, orgId: rowData.orgId }, query: { Risks: true } });
            } //for inactive page display
            // else if (this.$route.path.includes('/org/risks/inActive')) {
            //     if (rowData.systemId) {this.$router.push({name: 'worklogFromSystem',params: { riskId: rowData.id, systemId: rowData.systemId },query: { inActive: true}});} 
            //     else if (rowData.processId) {this.$router.push({name: 'worklogFromProcess',params: { riskId: rowData.id, processId: rowData.processId },query: { inActive: true }});} 
            //     else if (rowData.orgId) {this.$router.push({name: 'worklogFromOrganization',params: { riskId: rowData.id, orgId: rowData.orgId },query: { inActive: true }});}
            // }
        },
        changeInfoRisksPage(row: any, route: any) {
            emitter.emit('gotoInfoRisksPage', row);
        },
        changeRoute(row: any, route: any) {
            let selectedActionObj = {
                data: row,
                route: route
            };

            if (this.$route.path.includes('/org/system')) {
                emitter.emit('changeRouteInSystemInfo', selectedActionObj);
            } else if (this.$route.path.includes('/org/risks')) {
                emitter.emit('changeRouteInRisks', selectedActionObj);
            } else if (this.$route.path.includes('/systemRisks') || this.$route.path.includes('/processRisks') || this.$route.path.includes('/orgRisks')) {
                emitter.emit('changeRouteInTierRisks', selectedActionObj);
            } else if (this.$route.path.includes('/processInformation')) {
                emitter.emit('changeRouteInProcessInfo', selectedActionObj);
            } else if (this.$route.path.includes('/organizationInformation')) {
                emitter.emit('changeRouteInOrgInfo', selectedActionObj);
            }
        },
        toggleDropdown(event: any, index: any,column: any) {
            if (column == 'actionButton' || column == 'infoAction' || column == 'tableDataActions') {
                if (this.selectedRowIndex === index) {
                    this.showDropDown = !this.showDropDown;
                } else {
                    this.showDropDown = true;
                    this.selectedRowIndex = index;
                }
            } 

			const currentWidth = window.innerWidth;
			const { clientX, clientY } = event;

			let offset: any = 0;
			
			// Calculate available space below and above the cursor
			const spaceBelow = window.innerHeight - clientY;
			const spaceAbove = clientY;
			// console.log("fhjkhkjdalkjs",spaceBelow);
			// console.log("fhjkhkjdalkjs1",spaceAbove);

			// Position the dropdown based on available space
			if (spaceBelow > spaceAbove) {
                    if(column == 'actionButton' ){
                    // There is space below the cursor, so show the dropdown downwards
                    offset = 18; // Adjust this value if needed
                    this.dynamicTopPosition = clientY + offset; // Position the dropdown below the click
                }else{
                    // There is space above the cursor, so show the dropdown upwards
                    offset = 18; // Adjust this value if needed
                    this.dynamicTopPosition = clientY + offset;
                }
			} else if (spaceAbove > spaceBelow) {
                if(column == 'actionButton' ){
                    // There is space above the cursor, so show the dropdown upwards
                    offset = 20; // Adjust this value if needed
                    this.dynamicTopPosition = clientY+ offset; // Position the dropdown above the click
                }else{
                    // There is space above the cursor, so show the dropdown upwards
                    offset = -2; // Adjust this value if needed
                    this.dynamicTopPosition = clientY+ offset;
                }
			} else {
				// If there's no space either above or below, we can close the dropdown or do nothing
				this.showDropDown = false;
				return;
			}
            this.mouseY = event.clientY;
			// Horizontal position (keeping it based on clientX)
			this.dynamicLeftPosition = clientX - 100; // Adjust based on your design needs
			},
        actionOnClickingTableRow(rowData: any, index: any, column: any) {
            if (column == 'actionButton' || column == 'infoAction' || column == 'tableDataActions') {
                emitter.off('rowData', rowData);
            } else if (column == 'deleteinfo') {
                emitter.emit('deleteRow', rowData);
            } else if (column == 'History'||column =='inActiveHistory') {
                this.navigateWorkLog(rowData);
            } else if (column == 'deleteIcon') {
                let obj = {
                    entity: rowData,
                    index: index
                };
                emitter.emit('forDelete', obj);
            } else if (this.openPopup == true) {
                let obj = {
                    entityId: rowData.entityId,
                    index: index
                };
                let popupdata = {
                    entityData: rowData,
                    indexx: index
                };
                // emitter.emit('showData', obj);
                
                if(this.$route.path.includes('/org/approvals')){
                    emitter.emit('approvaldata', rowData);
                }else{
                    emitter.emit('showData123', popupdata);
                }
                
            } else if (this.entityId == 20008 && this.navigate == true && this.openPopup == false) {
                this.goToSystemRisk(rowData);
            } else if (this.entityId == 20012 && this.navigate == true && this.openPopup == false) {
                this.openTaskEditing(rowData._id);
            } else if (this.entityId == 20009 && this.navigate == true && this.openPopup == false) {
                this.gotoSystemInformation(rowData._id);
            } else if (this.entityId == 20006 && this.navigate == true && this.openPopup == false) {
                this.gotoProcessInformation(rowData._id);
            } else if (this.entityId == 20007 && this.navigate == true && this.openPopup == false) {
                emitter.emit('gotoInfoRisksPage', rowData);
            } else if (this.entityId == 20001 && this.navigate == true && this.openPopup == false) {
                this.gotoOrganizationInformation(rowData._id);
            } else {
                emitter.emit('rowData', rowData);
                this.showBlock = false;
                this.showDropDown = false
            }
            this.showBlock = false;
            this.showDropDown = false
        },
        toolTip(column: any, e: any, index: any, row: any, status: any) {
             let ValueKeys:any = ['impact','likelihood','Preview','priority','infopreview','severity','confValue','intValue','avaiValue','scValue','likeValue','opsValue','orgValue','businessValue','techValue','finValue','legalValue','severitypreview','prioritypreview','infoClassValue','proCValue','securityCategory','criticality']
           if(ValueKeys.includes(column)){
               this.tipText = this.getLabelDefinationName( row[column])
            }else{
               this.tipText = row[column];
            }
            this.tipColumn = column;
            this.tipIndex = index;
            switch (status) {
                case 'text':
                    // this.tipText = row[column];
                    this.handleTextTooltip(e,column);
                    break;
                case 'circleButton':
                        // this.tipText = row[column];
                        if(this.tipText == 1){
                           let obj:any = {
                                tipText : 'Active'
                                
                            }
                             emitter.emit('activiteToolTip',obj)
                        }else if(this.tipText == 2){
                           let obj:any = {
                                tipText : 'Inactive'
                            }
                            emitter.emit('activiteToolTip',obj)
                        }
                     break;
                     case 'label':
                        let ValueKeys:any = ['impact','overallImpact','likelihood','Preview','priority','infopreview','severity','confValue','intValue','avaiValue','scValue','likeValue','opsValue','orgValue','businessValue','techValue','finValue','legalValue','severitypreview','prioritypreview','infoClassValue','proCValue','securityCategory','criticality']
                        if(ValueKeys.includes(column)){
                            const container = e.currentTarget.querySelector('.table-ellipsisForValue');
                            if (container && this.isTextOverflowed(container)) {
                                let obj:any = {
                                    tipText : this.tipText
                                }
                                emitter.emit('activiteToolTip',obj)
                            }
                        }
                     break;
                case 'circle':
                    let findVal = this.dbSeverity.find((obj:any)=>{return obj.value == row[column]})

                    if(findVal != undefined){
                        this.tipText = findVal.key
                    }else{
                        this.tipText = row[column]
                    }

                    let obj:any = {
                        tipText : this.tipText
                    }
                    emitter.emit('activiteToolTip',obj)
            }
            this.showBlock = false;
            this.showDropDown = false
        },
        handleTextTooltip(e: any,column: any) {
            const container = e.currentTarget.closest('.table-ellipsis');
            if (container && this.isTextOverflowed(container)) {
                let obj:any = {
                    tipText : this.tipText
                }

              emitter.emit('activiteToolTip',obj)
            }
            else if (column === 'criticality'||column=='proCValue' && container) {
                const textContent = container.textContent?.trim() || '';
                let obj:any;
                if (
                    textContent.length > 12 || this.isTextOverflowed(container)
                ) {
                    if(this.dbProcessCriticality && this.dbProcessCriticality.length>0){
                        for(let i=0;i<this.dbProcessCriticality.length;i++){
                            if(this.tipText == this.dbProcessCriticality[i].value){
                                this.tipText = this.dbProcessCriticality[i].key                    
                                obj= {
                                    tipText: this.tipText
                                };
                            }
                        }
                    }
                    emitter.emit('activiteToolTip', obj);
                }
            }
        },
        isTextOverflowed(element: any) {
            return element.scrollHeight > element.clientHeight;
        },
        getDateFormat(date: any) {
            if (date == '') {
                return 'None';
            } else {
                let now = moment(date);
                return now.format('DD-MM-YYYY');
            }
        },
        openTaskEditing(taskId: any) {
            this.$router.push({ name: 'taskEditPage', params: { taskId: taskId } });
        },
        gotoSystemInformation(systemId: any) {
            this.$router.push({ name: 'systemInformation', params: { id: systemId } });
        },
        gotoProcessInformation(processId: any) {
            this.$router.push({ name: 'processInformation', params: { processId: processId } });
        },
        goToSystemRisk(risk: any) {
            if (Object.keys(risk).includes('systemId')) {
                this.$router.push({ name: 'tierRisks', params: { riskId: risk.mappedRisk, type: 'systemRisks' } });
            } else if (Object.keys(risk).includes('processId')) {
                this.$router.push({ name: 'tierRisks', params: { riskId: risk.mappedRisk, type: 'processRisks' } });
            } else if (Object.keys(risk).includes('orgId')) {
                this.$router.push({ name: 'tierRisks', params: { riskId: risk.mappedRisk, type: 'orgRisks' } });
            }
        },
        gotoOrganizationInformation(orgId: any) {
            this.$router.push({ name: 'organizationInformation', params: { orgId: orgId } });
        },
        async getOwnerName(ownerId: any) {
            await this.getAllUsers();
            let user;
            // if(Object.keys(ownerId).includes(ownerId)){
                user = this.optionsUserArray.find((obj: any) => {
                    return (obj.value == ownerId.value);
                });
            // }
            
            if (user == undefined) {
                let empty = 'N/A';
                return empty;
            } else {
                return user.label;
            }
        },
        colorPropBg(format: any, scaleScore: any) {
            if (format == 'circle') {
                if (scaleScore == 5) {
                    return ['bg-darkred'];
                } else if (scaleScore == 4) {
                    return ['bg-error'];
                } else if (scaleScore == 3) {
                    return ['bg-yellow'];
                } else if (scaleScore == 2) {
                    return ['bg-green'];
                } else if (scaleScore == 1) {
                    return ['bg-lightgreen'];
                }
            } else if (format == 'border') {
                if (scaleScore == 5) {
                    return ['border-darkred border-4'];
                } else if (scaleScore == 4) {
                    return ['border-error border-4'];
                } else if (scaleScore == 3) {
                    return ['border-yellow border-4'];
                } else if (scaleScore == 2) {
                    return ['border-green border-4'];
                } else if (scaleScore == 1) {
                    return ['border-lightgreen border-4'];
                }
            }
        },
        colorRiskText(value: any) {
            if (value == 1) {
                return ['text-lightgreen font-semibold'];
            } else if (value == 2) {
                return ['text-green font-semibold'];
            } else if (value == 3) {
                return ['text-yellow font-semibold'];
            } else if (value == 4) {
                return ['text-error font-semibold'];
            } else if (value == 5) {
                return ['text-darkred font-semibold'];
            }
        },
        colorRiskBg(value: any) {
            if (value == 1) {
                return ['veryLowOpacity border-solid border border-lightgreen'];
            } else if (value == 2) {
                return ['LowOpacity border-solid border border-green'];
            } else if (value == 3) {
                return ['ModerateOpacity border-solid border border-yellow'];
            } else if (value == 4) {
                return ['HighOpacity border-solid border border-error'];
            } else if (value == 5) {
                return ['veryHighOpacity border-solid border border-darkred'];
            }
        },
        colorsForStatusesText(stat: any) {
            if (stat == 10410) {
                return ['text-darkred', 'border-solid border border-darkred font-semibold'];
            } else if (stat == 10408) {
                return ['text-primary', 'border-solid border border-primary font-semibold'];
            } else if (stat == 10403) {
                return ['text-lightgreen', 'border-solid border border-lightgreen font-semibold'];
            } else if (stat == 10409) {
                return ['text-darkred', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-darkred'];
            } else if (stat == 10402) {
                return ['text-electricGreen', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-electricGreen'];
            } else if (stat == 10404) {
                return ['text-primary', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-primary'];
            } else if (stat == 10401) {
                return ['text-darkred', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-darkred'];
            } else if (stat == 10406) {
                return ['text-yellow', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-yellow'];
            } else if (stat == 10407) {
                return ['text-green', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-green'];
            } else if (stat == 10405) {
                return ['text-lightgreen', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-lightgreen'];
            } else if (stat == 10419) {
                return ['text-green', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-green'];
            } else if (stat == 10425) {
                return ['text-resetBlue', 'px-2.5 py-1 flex justify-center font-semibold border-solid border border-resetBlue'];
            }
        },
        bgColorsForStatuses(code: any) {
            if (code == 10410) {
                return ['bg-darkred'];
            } else if (code == 10403) {
                return ['bg-lightgreen'];
            } else if (code == 10401) {
                return ['bg-darkred'];
            } else if (code == 10408) {
                return ['bg-primary'];
            } else if (code == 10402) {
                return ['bg-electricGreen'];
            } else if (code == 10404) {
                return ['bg-primary'];
            } else if (code == 10409) {
                return ['bg-darkred'];
            } else if (code == 10406) {
                return ['bg-yellow'];
            } else if (code == 10405) {
                return ['bg-lightgreen'];
            } else if (code == 10407) {
                return ['bg-green'];
            } else if (code == 10419) {
                return ['bg-green'];
            } else if(code == 10425) {
                return['bg-resetBlue']
            }
        },
        colorRiskStatusBg(Status: any) {
            if (Status == 10401) {
                return ['bg-darkred', 'opacity-10'];
            } else if (Status == 10402) {
                return ['bg-electricGreen', 'opacity-10'];
            } else if (Status == 10403) {
                return ['bg-primary', 'opacity-10'];
            } else if (Status == 10404) {
                return ['bg-primary', 'opacity-10'];
            } else if (Status == 10405) {
                return ['bg-lightgreen', 'opacity-10'];
            } else if (Status == 10406) {
                return ['bg-yellow', 'opacity-10'];
            } else if (Status == 10425) {
                return ['bg-resetBlue', 'opacity-10']
            } 
            else if (Status == 10419) {
                return ['bg-yellow', 'opacity-10'];
            }
        },
        colorRiskStatusText(Status: any) {
            if (Status == 10401) {
                return ['text-darkred', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-darkred'];
            } else if (Status == 10402) {
                return ['text-electricGreen', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-electricGreen'];
            } else if (Status == 10403) {
                return ['text-primary', 'px-2.5 py-1 flex justify-center font-semibold border-solid border border-primary'];
            } else if (Status == 10404) {
                return ['text-primary', 'px-2.5 py-1 flex justify-center font-semibold border-solid border border-primary'];
            } else if (Status == 10405) {
                return ['text-lightgreen', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-lightgreen'];
            } else if (Status == 10406) {
                return ['text-yellow', 'px-2.5 py-1 flex justify-center font-semibold border-solid border border-yellow'];
            }  else if (Status == 10425) {
                return ['text-resetBlue', 'px-2.5 py-1 flex justify-center font-semibold border-solid border border-resetBlue'];
            }else if (Status == 10419) {
                return ['text-yellow', 'px-2.5 py-1 flex justify-center font-semibold border-solid border border-yellow'];
            }
        },
        doFalse() {
            emitter.emit('deActiviteToolTip')
        },
        async getAllUsers() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/getAll`).then((res: any) => {
                this.users = res.data;
            });
            for (var i = 0; i < this.users.length; i++) {
                this.optionsUserArray.push({ label: this.users[i].name, value: this.users[i]._id });
            }
        },
        getOwnerType(input: any) {
            let type = this.orgType.find((l: any) => {
                return l.id == input;
            });
            if (type == undefined) {
                return input;
            } else {
                return type.value;
            }
        },
        // clickOnEditOrDeleteAction(data: any, index: any) {
        //     console.log('Table data', data);
        //     if (this.selectedRowIndex === index) {
        //         this.showTableActionsDropdown = !this.showTableActionsDropdown;
        //     } else {
        //         this.showTableActionsDropdown = true;
        //         this.selectedRowIndex = index;
        //         let selectedRow = {
        //             entityData: data,
        //             indexx: index
        //         };
        //         console.log('asdfghjkl;poiuytreqwertyuiop', selectedRow);
        //         this.popupDataEmittingObject = selectedRow;
        //     }
        //     console.log(data, index);
        // },
        tableDataDeleteAction(data: any, index: any) {
            // this.showTableActionsDropdown = !this.showTableActionsDropdown;
            let obj = {
                entityData: data,
                index: index
            };
            this.showDropDown=false
            emitter.emit('deleteData', obj);
        },
        tableDataEditAction(data: any, index: any) {
            // this.showTableActionsDropdown = !this.showTableActionsDropdown;
            let obj = {
                entityData: data,
                index: index
            };
            emitter.emit('showPopupData', obj);
        },
        changePriority(data: any) {
            emitter.emit('showPriorityPopup', data);
            
        },
 
        textColorForPriority(value: any) {
            if (value == 1) {
                return ['text-lightgreen font-semibold'];
            } else if (value == 2) {
                return ['text-green font-semibold'];
            } else if (value == 3) {
                return ['text-yellow font-semibold'];
            } else if (value == 4) {
                return ['text-error font-semibold'];
            } else if (value == 5) {
                return ['text-darkred font-semibold'];
            }
        },
        bgColorForPriority(value: any) {
            if (value == 1) {
                return ['veryLowOpacity border-solid border border-lightgreen'];
            } else if (value == 2) {
                return ['LowOpacity border-solid border border-green'];
            } else if (value == 3) {
                return ['ModerateOpacity border-solid border border-yellow'];
            } else if (value == 4) {
                return ['HighOpacity border-solid border border-error'];
            } else if (value == 5) {
                return ['veryHighOpacity border-solid border border-darkred'];
            }
        },
        bgColorForTreatmentType(value: any) {
             if (value == 10403) {
                return ['veryLowOpacity border-solid border border-lightgreen'];
            } else if (value == 10405) {
                return ['LowOpacity border-solid border border-green'];
            } else if (value == 10419) {
                return ['ModerateOpacity border-solid border border-yellow'];
            } else if (value == 10407) {
                return ['HighOpacity border-solid border border-error'];
            } else if (value == 10425) {
                return ['bg-electricGreen/20 border-solid border border-electricGreen'];
            } else if(value==10424){
                return ['bg-darkred/20 border-solid border border-darkred'];
            } else if(value==10404){
                return ['bg-primary/20 border-solid border border-primary'];
            }
        },
        textColorForTreatmentType (value: any) {
            if (value == 10403) {
                return ['text-lightgreen font-semibold'];
            } else if (value == 10405) {
                return ['text-green font-semibold'];
            } else if (value == 10419) {
                return ['text-yellow font-semibold'];
            } else if (value == 10407) {
                return ['text-error font-semibold'];
            } else if (value == 10425) {
                return ['text-electricGreen font-semibold'];
            }else if(value==10424){
                return ['text-darkred font-semibold'];
            }else if(value==10404){
                return ['text-primary font-semibold'];
            }
        },

        getColumnLabel(columnName: any) {
            let labelKeys:any = ['confLabel','intLabel','avaiLabel','scLabel','likeLabel','opsLabel','orgLabel','businessLabel','techLabel','finLabel','legalLabel','sevLabel','prioLabel','infoClassLabel','proCLabel','overAllLabel']
            let ValueKeys:any = ['confValue','intValue','avaiValue','scValue','likeValue','opsValue','orgValue','businessValue','techValue','finValue','legalValue','severitypreview','prioritypreview','infoClassValue','proCValue','overAllValue']

            if (columnName == 'actionButton' || columnName == 'deleteinfo' || columnName == 'infoAction' || columnName == 'deleteIcon' || columnName == 'tableDataActions'||columnName=='deleteIcon' || columnName == 'History'||columnName=='inActiveHistory') {
                return '';
            }else if(labelKeys.includes(columnName)){
                return 'Label';
            }else if(ValueKeys.includes(columnName)){
                return 'Value';
            }
            
            const column = this.columns.find((col: { key: any }) => col.key === columnName);
            return column ? column.value : columnName;
        },
        getColumnRealtedValueFromArray(cameValue: any, type: any) {
            // console.log('sazxsadsad', cameValue);
            if(cameValue == 'N/A'){
                return 'N/A'
            }
            if(cameValue!=undefined && type=='statusCode'){
                const option = this.statuses.Risks?.find((soption: { id: any }) => soption.id === cameValue);
                return option ? option?.label : [];
            }
            if(cameValue!=undefined && type=='treatmentType'){

                const option = this.statuses.TreatmentType?.find((soption: { id: any }) => soption.id === cameValue);
                return option ? option?.label : [];
            }
            if(cameValue!=undefined && type=='approvalStatus'){
                const option = this.statuses.Approvals?.find((soption: { id: any }) => soption.id === cameValue);
                return option ? option?.label : [];
            }
            if(cameValue != undefined){
                const option = this.dropdownOptions.find((option: { key: any }) => option.key === type);
                const option1 = option.value.find((soption: { id: any }) => soption.id === cameValue);
                return option ? option1?.value : [];
            }
        },
        isColumnArrayPresentibDB(column:any){
            let ValueKeys:any = ['impact','overallImpact','likelihood','overAllValue','priority','infopreview','severity','confValue','intValue','avaiValue','scValue','likeValue','opsValue','orgValue','businessValue','techValue','finValue','legalValue','severitypreview','prioritypreview','infoClassValue','proCValue','securityCategory']
            if(ValueKeys.includes(column)){
                return true
            }else{
                return false
            }
        },
        getDbDropdownOptionsForFilter(column:any){
            if(column=='priority' || column=='prioritypreview'){
                return this.dbPriority
            }else if(column=='severity' || column=='severitypreview'){
                return this.dbSeverity
            }else if(column=='impact' ||column=='overallImpact'|| column=='overAllValue'){
                return this.dbOverAllImpact
            }else if(column=='confValue'){
                return this.dbConfidentiality
            }else if(column=='intValue'){
                return this.dbIntegrity
            }else if(column=='avaiValue'){
                return this.dbAvailability
            }else if(column=='scValue' || column=='securityCategory'){
                return this.dbSecurityCategory
            }else if(column=='likeValue' || column=='likelihood'){
                return this.dbLikelihood
            }else if(column=='opsValue'){
                return this.dbOperations
            }else if(column=='orgValue'){
                return this.dbOrganization
            }else if(column=='businessValue'){
                return this.dbBussiness
            }else if(column=='techValue'){
                return this.dbTechnical
            }else if(column=='finValue'){
                return this.dbFinancial
            }else if(column=='legalValue'){
                return this.dbLegal
            }else if(column=='infoClassValue' || column=='infopreview'){
                return this.dbInformationClassification
            }else if(column=='proCValue'){
                return this.dbProcessCriticality
            }
        },
        isColumnArrayPresent(columnName: any) {
            if(columnName == 'priority'){
                return true
            }
            return this.dropdownOptions.some((option: { key: any }) => option.key === columnName);
        },
        getDropdownOptionsForFilter(columnName: any) {
            const option = this.dropdownOptions.find((option: { key: any }) => option.key === columnName);
            return option ? option.value : [];
        },

        checkDateFormat(column: any) {
            if (column == 'createdAt' || column == 'updatedAt' || column=='createdAtfirst') {
                return true;
            }
        },

        checkuserData(column: any) {
            if (column == 'riskOwner') {
                return true;
            }
        },
        shouldShowDisabled(columnName:any)
        {
            
                return false;  
        },
        isFilterNotNecessary(columnName:any)
        {
            if(columnName == 'actionButton'||columnName=='Facing'||columnName=='risks'||columnName=='deleteIcon' || columnName == 'tableDataActions' || columnName == 'History' ||columnName=='inActiveHistory'|| columnName == 'systemCount' || columnName == 'createdAt' || columnName == 'updatedAt' || columnName == 'Phone'||columnName == 'Contract Start Date' || columnName == 'Contract Expiry Date' || columnName == 'first Identified' || columnName == 'deactivated On' || columnName == 'createdAtfirst'||columnName=='statusCode'||columnName=='treatmentType'||columnName=='mitigationTier'||columnName=='taskStatus'||columnName=='impact'||columnName=='overallImpact'||columnName=='likelihood')
            {
                return true;
            }
            
                return false;
        },
        handleResize() {
            this.showDropDown = false;
        }
    },
    async created() {
		await this.getRiskApprovalStatuses()
	},
});
</script>